import { render } from "./IncomeItemsModal.vue?vue&type=template&id=029f48fc&scoped=true"
import script from "./IncomeItemsModal.vue?vue&type=script&lang=js"
export * from "./IncomeItemsModal.vue?vue&type=script&lang=js"

import "./IncomeItemsModal.vue?vue&type=style&index=0&id=029f48fc&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-029f48fc"]])

export default __exports__